import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Fab,
  DialogActions,
  Tabs,
  Tab,
  Autocomplete,
  Divider,
  Chip
} from "@mui/material";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from "@mui/material/Tooltip";
import { Check as CheckIcon, Clear as ClearIcon, Close, CropSharp, Details } from "@mui/icons-material";
import { CloseOutlined } from "@mui/icons-material";
import { Stack } from "@mui/material";
import styled from "styled-components";
import { ACTIVITY_STATUS, ROLES } from "../../constants";
import moment from "moment";
import OpaqueLoading from "../opaqueLoading/opaqueLoading";
import { DataGrid, GridToolbarColumnsButton, GridToolbarContainer, GridToolbarDensitySelector, GridToolbarExport, GridToolbarFilterButton } from "@mui/x-data-grid";
import { AuthContext } from "../contextAPI/ContextAPI";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from "dayjs";

 
const isMobile = window.innerWidth < 900;
 
const TotalAmountTypography = styled(Typography)`
 
  position: absolute;
 
  bottom: 10px;
 
  right: 10px;
 
  font-size: ${isMobile ? "14px" : "inherit"};
 
  bottom: ${isMobile ? "85px" : "70px"};
 
  right: ${isMobile ? "15px" : "70px"};
 
`;
const ModalHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  padding: 10px;
`;
const TableContainer = styled.div`
  // height: calc(
  //   100vh - ${isMobile ? "106px - 20px - 82.23px" : "100px - 20px - 23.77px"}
  // );
  width: ${isMobile?"100%":"98%"};
  // border: solid 1px lightGrey;
  border-radius: 8px;
  margin-left:${isMobile?"0px":"10px"};
  margin-bottom:${isMobile?"0px":"10px"};

`;
const InputFieldContainer = styled.div`
  margin: 20px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  label {
    margin-bottom: 0px;
  }
`;
const TabsContainer = styled.div`
  ${isMobile && `
    height: calc(100vh - 176px - 20px - 43.77px);
  `}
`
const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;
 
const ModalActionsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
`;
 
const FirstButton = styled(Button)`
  margin-right: 10px !important;
`;
 
const StyledDialogContent = styled(DialogContent)`
  padding: 16px;
`;
 
const StyledDialog = styled(Dialog)`
  position: relative;
`;
 
const FabStyle = styled(Fab)`
  && {
    z-index: 1;
  }
`;
 
const DataGridContainer = styled.div`
  width: 100%;
 
 
`;
const DataGridContainer1 = styled.div`
  width: 100%;
  margin-bottom:${!isMobile&& "20px"};
 
//   height: 500px;
`;
 
const NoteText = styled(Typography)`
  margin-top: 10px !important;
`;
 
const Input = styled.input`
  display: none;
`;
 
 
const AllotSpecimenModal = ({ props,onClose,remarks,dataProp,id,distributorId,fetchData,status}) => {
  console.log("DATA0PROPA",dataProp);
  const [tabValue, setTabValue] = useState(0);

  const [loading,setLoading]=useState(false)
const [product,setProduct]=useState([])

 const [form,setForm]=useState({
 })

 const [errors, setErrors] = useState({});
 const [employee,setEmployee]=useState([])
 const [assignedEmp,setAssignedEmp]=useState()
 const [party,setParty]=useState(null)
 const [selectParty,setSelectParty]=useState(null)
 const [party1,setParty1]=useState(null)
 const [selectParty1,setSelectParty1]=useState(null)


 const [date,setDate]=useState()
 const [qty,setQty]=useState()

 



 const [selectedProduct,setSelectedProduct]=useState(null)
 const [dataGrid,setDataGrid]=useState([])
 const [visitType,setVisitType]=useState([])

 const today = dayjs();
 const tomorrow = today.add(1, 'day');
 const dayAfterTomorrow = today.add(7, 'day');

  const handleChangeTab = (event, newValue) => {
    console.log("newValue: " , newValue);
    setTabValue(newValue);
  };
   

  const formatDate=(data)=>{
    console.log("DATAAAA",data   )
    // setDate(data)
    const timestamp = new Date(data.$d);
    
    const datePickerResponse = new Date(data.$d);

    const year = datePickerResponse.getFullYear();
const month = String(datePickerResponse.getMonth() + 1).padStart(2, '0');
const day = String(datePickerResponse.getDate()).padStart(2, '0');
const formattedDate = `${year}-${month}-${day}`;
const unixTimestamp = Math.floor(timestamp.getTime() / 1000);
setDate(data)


changeHandler("date",unixTimestamp)
console.log("UNIX",unixTimestamp);
}
  console.log("FORMM",form)
 
useEffect(()=>{
// if(tabValue===1){
//   fetchProduct(plantCode,distributorId)
// }
fetchEmployees()
fetchSpecimen()

// getSchool()
// getPartyLead()

console.log("currentTab", tabValue)
},[])

useEffect(()=>{
    // if(tabValue===1){
    //   fetchProduct(plantCode,distributorId)
    // }
    // getSchool({ownerId:form.ownerId})
    // getPartyLead({ownerId:form.ownerId})
    // getRouteVisitType()
    
    console.log("currentTab", tabValue)
    },[form.ownerId])
 




const changeHandler = (fieldName, value) => {
    // console.log(value)
    setForm((prevForm) => ({ ...prevForm, [fieldName]: value }));
  };

  const getSchool=async(details)=>{
    try{
      setLoading(true)
      // console.log("PLANTCODE",plantcode[0].plant_code__c)
      let results = await window.Platform.database.getSchool(details);
//   console.log("pincode: " ,results.data[0].StateName)
setParty(results.data)
    setLoading(false)
  
  // setDetails(results.data[0]);
  // setProduct(results.data)
  }
  catch(err){
    console.log(err);
  setLoading(false)
   
    }
  }

  const getPartyLead=async(details)=>{
    try{
      setLoading(true)
      // console.log("PLANTCODE",plantcode[0].plant_code__c)
      let results = await window.Platform.database.getPartyLead(details);
//   console.log("pincode: " ,results.data[0].StateName)
setParty1(results.data)
    setLoading(false)
  
  // setDetails(results.data[0]);
  // setProduct(results.data)
  }
  catch(err){
    console.log(err);
  setLoading(false)
   
    }
  }

  const fetchSpecimen=async()=>{
    let results = await window.Platform.database.getSpecimen();
    setVisitType(results.data)

  }
  const getRouteVisitType=async(details)=>{
    try{
      setLoading(true)
      // console.log("PLANTCODE",plantcode[0].plant_code__c)
      let results = await window.Platform.database.getRouteVisitType(details);
//   console.log("pincode: " ,results.data[0].StateName)
setVisitType(results.data)
    setLoading(false)
  
  // setDetails(results.data[0]);
  // setProduct(results.data)
  }
  catch(err){
    console.log(err);
  setLoading(false)
   
    }
  }


const renderContent1=()=>{
  return (
    <div style={{ overflowY:"auto" }}>
   
        
          <Stack direction={"row"} spacing={2} padding={2}>
          <Autocomplete
            options={employee}
            // getOptionLabel={}
            // getOptionLabel={(option) => `${option?.name} (${option?.id})`}
            getOptionLabel={(option) => `${option?.name}`}
              getOptionValue={(option) => option?.id || ''}
            style={{ width: "100%" }}
            value={assignedEmp}
            // disabled={loading 
              // || !addNewMode || props.isManager
            // }
            noOptionsText={loading ? "Loading..." : "No option"}
              onChange={(event, value) => {
                console.log("TEST1212",value)
                changeHandler("ownerId", value.id)
                setAssignedEmp(value)
                //  updateDataGrid(value);
                
                // if(selectedCity.warehouseCountry === 'India' && warehouseData.attributes.warehouseCountry === 'China')
                // {
                //     setDisableTransfer(false)
                // }
                // else
                // setDisableTransfer(true)

               
                
              }}
              onInputChange={(e, value) => {
                // Check if the user's input matches any option
                const matchingOption = employee.find((option) => option.name === value.name);

                
              }}
            renderInput={(params) => (
              <TextField
                {...params}
                // disabled={
                //   loading 
                  // || !addNewMode || props.isManager || props.isDeleted
                // }
                label={"Assign To"}
                required
                variant="outlined"
                error={errors.ownerId ? true : false}
              />
            )}/>
           
           
          </Stack>
          <Stack direction={"row"} spacing={2} padding={2} >
          <Stack direction={"row"} spacing={2} sx={{width:"100%"}}>
       
    <Autocomplete
            options={visitType}
            // getOptionLabel={}
            // getOptionLabel={(option) => `${option?.nameSku} (${option?.skuId})`}
            getOptionLabel={(option) => `${option?.nameSku}`}
            getOptionValue={(option) => option?.skuId }
            style={{ width: "100%" }}
            value={selectParty}
            disabled={loading 
              || !form.ownerId
            }
            onChange={(event, value) => {
                console.log("TEST1212",value?.skuId)
                setSelectParty(value)
                //  updateDataGrid(value);
                
                // if(selectedCity.warehouseCountry === 'India' && warehouseData.attributes.warehouseCountry === 'China')
                // {
                //     setDisableTransfer(false)
                // }
                // else
                // setDisableTransfer(true)
  
               
                
              }}
             
            renderInput={(params) => (
              <TextField
                {...params}
                // disabled={
                //   loading 
                  // || !addNewMode || props.isManager || props.isDeleted
                // }
                label={"Select Specimen"}
                required
                variant="outlined"
                error={errors.specimen ? true : false}
              />
            )}/>
            <TextField label="QTY" value={qty||""} onChange={(e)=> onlyNumeric(e)}/>


            <Button variant="text" disabled={!selectParty||!qty} onClick={()=>additem()}>Add</Button>
        </Stack>
        
        </Stack>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

        <DataGrid
          style={{ height: !dataGrid.length ? '200px' : 'auto' }}
          className="payrollGrid"
        //   checkboxSelection={true}
        
        sx={{height:isMobile ? "555px":"240px",maxWidth:"97%"}}
        density="compact"
      //   checkboxSelection={true}
          rows={dataGrid||[]}
          columns={getColumns()}
          rowHeight={40}
          // onRowSelectionModelChange={handleSelectionModelChange}
          disableSelectionOnClick
          disableRowSelectionOnClick
          // autoPageSize

          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10]}          // components={{
          //   Toolbar: CustomToolbar,
          // }}
        />
         
       </div>
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center',margin:"20px",marginTop:"35px" }}>
      <Button variant="contained" onClick={()=>onsubmit()}>
        Submit
      </Button>
      </div>
         
     
      
</div>
)}





const additem=()=>{
  console.log("SELECTEDPRODUCT",selectParty)
  const length=dataGrid.length+1
  let pushedItem={"name":selectParty.nameSku,"skuId":selectParty.skuId,qty:qty,id:length}

  setSelectParty(null)
  setQty(null)
  
  setDataGrid([...dataGrid,pushedItem])

}

const additem1=()=>{
    console.log("SELECTEDPRODUCT",selectParty1)
    const length=dataGrid.length+1
    let pushedItem={"name":selectParty1.leadName,"leadId":selectParty1.leadId,type:"Lead",id:length}
    setSelectParty1(null)
    setDataGrid([...dataGrid,pushedItem])
  
  }



  const fetchEmployees=async(data)=>{
    const results = await window.Platform.database.getUsersForWork(data);
    setEmployee(results.data)
   }

  const onlyNumeric = (event) => {
    if (isNaN(event.target.value)) {
        const qty = event.target.value.replace(/\D/g, "");
        setQty(qty);
    } else {
      setQty(event.target.value);
    }
  }

  const validateForm = (data) => {
    const errors = {};
 
    if (!data.ownerId?.trim()) {
      errors.ownerId = "Assign to is required";
    }

    if (data.ownerId?.trim()) {
      if(!dataGrid.length) {
        if (!data.specimen?.trim()) {
          errors.specimen = "Specimen is required";
        }
      }
    }
      
    return errors;
  };
  
 
  const onsubmit=async(data)=>{
    try{

      const errors = validateForm(form);
      setErrors(errors);

      if (Object.keys(errors).length === 0) {
        setLoading(true);

        const finalData={ownerId:form.ownerId,item:dataGrid,approvalStatus:'1'};
        const results = await window.Platform.database.addSpecimenToUser(finalData);
        
        window.NotificationUtils.showSuccess("Specimen Added Successfully!");
        setLoading(false);
        onClose();
        fetchData();
      } else {
        window.NotificationUtils.showError("Please fill all required fields.");
        setLoading(false);
      }

  }
    catch(error){
    console.log(error)
    setLoading(false)

    }
      }
      const getColumns = () => {
        let result = [
          {
            field: "leadName",
            headerName: "SKU Name",
            sortable: false,
            width: 300,
            
            editable: false,
            renderCell: (params) => {
      
              let name = params.row?.name||"N/A"
      
              return (
      
                <Tooltip title={name || "N/A"}>
      
                  <Typography variant="inherit">{name}</Typography>
      
                </Tooltip>
      
              )
      
            },
          },
          {
            field: "type",
            headerName: "QTY",
            sortable: false,
            width: 150,
            
            editable: false,
            renderCell: (params) => {
      
              let name = params.row?.qty||"N/A"
      
              return (
      
                <Tooltip title={name || "N/A"}>
      
                  <Typography variant="inherit">{name}</Typography>
      
                </Tooltip>
      
              )
      
            },
          },
        
            {
              field: "Actions",
              headerName: "Actions",
              width: 100,
              // height: 10,
              // headerAlign: 'center',
              sortable: false,
              // editable: true,
              renderCell: (params) => {
        
                let name =params.row.total||"N/A"
        
                return (
        
                 <IconButton onClick={()=>handleDeleteEmploye(params.row.id)}>
<DeleteIcon/>
                 </IconButton>
        
                )
        
              },
            },
      
           
      
       
        ];
      
      
        return result
      }



      const handleDeleteEmploye = async (id) => {
        // const response = await window.Platform.database.deleteUsers(ID);
    
        let res = dataGrid.filter((el) => {
          return el.id != id;
        });
    
        setDataGrid(res);
      };

      
 
  return (
    <Dialog disableEnforceFocus maxWidth="md" fullWidth={true} open={true} >
     {loading && <OpaqueLoading/>}
    <ModalHeaderContainer style={{marginBottom:2,paddingBottom:3}}>
       <Typography  variant={isMobile?"h6":"h5"}>
        Allot Specimen 
         <Tooltip title="Order Id">
 
           {id}
         </Tooltip>
           
           </Typography>
       <IconButton onClick={onClose} >
         <CloseOutlined />
       </IconButton>
     </ModalHeaderContainer>
     <TableContainer>
 
     <TabsContainer>
            <StyledTabs
              variant="fullWidth"
              value={tabValue}
              onChange={ handleChangeTab}
              indicatorColor="primary"
              textColor="primary"
            >
              <Tab label="Route Details" />
           
            </StyledTabs>
            {tabValue==0&& renderContent1()}
 
          </TabsContainer>
   
     </TableContainer>
 
   </Dialog>
  );
};
 
export default AllotSpecimenModal;